<section class="booking-summary">
  <div class="brand-info">
    <a
      [href]="MIYANA_WEBSITE"
      class="btn-without-filled without-border button-return-sitio"
    >
      <span class="icon-Arrow-Back"></span>
      Regresar al sitio del proyecto
    </a>

    <section class="brand-logos">
      <img [src]="bookingData.projectLogo" />
    </section>
  </div>

  <div class="container-of-visit-information">
    <div class="wrapper-info-and-visit-data property-flow">
      <h2>
        ¡Gracias<span *ngIf="showName">,</span>
        <span *ngIf="showName">
          {{
            withSession
              ? nameWithSession
              : bookingData?.name || bookingData?.firstName
          }} </span
        >!
      </h2>
      <p class="body-subtitle">Has agendado una nueva visita</p>

      <section class="details">
        <div class="two-columns">
          <section class="datetime">
            <p class="subtitule-2 info">
              Fecha y hora
              <img src="/assets/img/icons/clock.svg" />
            </p>
            <p class="body-2">{{ date }} {{ bookingData?.hour }} hrs</p>
          </section>
          <section class="typeDepartment">
            <p class="subtitule-2">
              Interesado en
              <img src="/assets/img/icons/location.svg" />
            </p>
            <p class="body-2">{{ bookingData.propertyName }}</p>
          </section>
        </div>
      </section>

      <img class="smart-logo" src="/assets/img/logos/smart-walk-s.svg" />
    </div>

    <div class="wrapper-steps-to-follow property-flow">
      <h2>¿Qué debes hacer ahora?</h2>

      <div class="steps first">
        <h3>1</h3>
        <p class="body-2" *ngIf="showName">
          Si creaste tu cuenta con correo electrónico, busca la invitación a
          SmartWalk en tu buzón de entrada o en tu
          <span class="bold">correo no deseado</span> para generar tu
          contraseña.
        </p>
        <p class="body-2" *ngIf="!showName">
          Recibirás un correo electrónico con los datos y el link de tu visita.
          Busca el correo en tu buzón de entrada o en tu
          <span class="bold">correo no deseado</span>.
        </p>
      </div>

      <div class="steps first">
        <h3>2</h3>
        <p class="body-2" *ngIf="showName">
          Ingresa a la plataforma de SmartWalk.
        </p>
        <p class="body-2" *ngIf="!showName">
          El día de tu visita entra al link que se te proporcionó y valida tu
          correo electrónico para entrar a la videollamada. Un asesor estará
          esperándote para mostrarte la propiedad.
        </p>
      </div>

      <div class="steps">
        <h3>3</h3>
        <p class="body-2" *ngIf="showName">
          Visualiza la visita virtual que agendaste y entra a verla en el
          horario reservado. Puedes invitar a otras personas solo con un correo
          electrónico.
        </p>
        <p class="body-2" *ngIf="!showName">
          Al finalizar tu visita, podrás dar de alta una cuenta para poder darle
          seguimiento a tus visitas si así lo deseas.
        </p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="bookingData.interests?.length">
    <section class="interests">
      <div class="subtitule-2">Te mostraremos el espacio enfocándonos en:</div>

      <div class="interest" *ngFor="let interest of bookingData.interests">
        {{ interest.name }}
      </div>
    </section>
  </ng-container>

  <section class="wrapper-button-go-account">
    <button
      type="button"
      class="btn-filled"
      *ngIf="bookingData?.name || bookingData?.firstName"
      (click)="redirectToLogin()"
    >
      Ir a mi cuenta
      <i class="icon-Arrow-Front"></i>
    </button>
  </section>
</section>
